export function loadMoreTeam() {
    $(".show-more-team .button").on('click', function (e) {
        e.preventDefault();
        let $this = $(this);
        let $hiddenItems = $this.parent().prev(".team-list").find(".hidden");
        $this.hide();
        $hiddenItems.css("display", "flex");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/loadMoreTeam.js